import { render, staticRenderFns } from "./ProjectType.vue?vue&type=template&id=1c1ded8e&"
import script from "./ProjectType.vue?vue&type=script&lang=ts&"
export * from "./ProjectType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports